import { Text } from '../../../../../../../../../ui/index.ts';
import { Container } from '../../styles.ts';
import { useTextsController } from './controller/index.ts';

export function Texts() {
  const { text1, text2, text4, text3, text5 } = useTextsController();

  return (
    <Container gridTemplateRows="repeat(5, max-content)" gap="20">
      <Text text={text1} color="black-primary" size={16} weight="Medium" />
      <Text text={text2} color="black-primary" size={16} weight="Medium" />
      <Text text={text3} color="black-primary" size={16} weight="Medium" />
      <Text text={text4} color="black-primary" size={16} weight="Medium" />
      <Text text={text5} color="black-primary" size={16} weight="Medium" />
    </Container>
  );
}
